import type { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './constants';
import type { IDeleteTourState } from './interface';

const reset = (state: IDeleteTourState, action: PayloadAction) => ({ ...initialState });

const updateSession = (
    state: IDeleteTourState,
    action: PayloadAction<{ userSession?: string }>,
) => ({
    ...state,
    userSession: action.payload.userSession ?? '',
});

const updateLanguageId = (
    state: IDeleteTourState,
    action: PayloadAction<{ languageId?: number }>,
) => ({
    ...state,
    languageId: action.payload.languageId ?? -1,
});

const updateTourId = (state: IDeleteTourState, action: PayloadAction<{ tourId?: number }>) => ({
    ...state,
    tourId: action.payload.tourId ?? -1,
});

const hideProgressBar = (state: IDeleteTourState, action: PayloadAction) => ({
    ...state,
    progressVisible: false,
});

const showProgressBar = (state: IDeleteTourState, action: PayloadAction) => ({
    ...state,
    progressVisible: true,
});

const setProgress = (state: IDeleteTourState, action: PayloadAction<{ progress: number }>) => ({
    ...state,
    progressBar: action.payload.progress,
});

export default Object.freeze({
    reset,
    updateSession,
    updateLanguageId,
    updateTourId,
    hideProgressBar,
    showProgressBar,
    setProgress,
});
